import { env } from '@/lib/env';
import { ROUTES } from '@/constants/routes';

/**
 * Barita OAuth2 configuration. BFM Online authenticates exclusively against
 * this server (`VITE_OAUTH_AUTHORIZE_URL`) — there is no local credential
 * store, so every value here describes how we talk to Barita, never how we
 * would validate a password ourselves.
 */
export const oauthConfig = {
  authorizeUrl: env.VITE_OAUTH_AUTHORIZE_URL,
  clientId: env.VITE_OAUTH_CLIENT_ID,
  scope: env.VITE_OAUTH_SCOPE,
  responseType: env.VITE_OAUTH_RESPONSE_TYPE,
  issuer: env.VITE_OAUTH_ISSUER || undefined,
  jwksUri: env.VITE_OAUTH_JWKS_URI || undefined,
};

/**
 * The exact callback URL this app presents as `redirect_uri`. Barita OAuth
 * servers match this string exactly against what's registered for the
 * client id, so prefer the explicit env override when one is configured and
 * otherwise derive it from wherever the app is actually running.
 */
export function getRedirectUri(): string {
  return env.VITE_OAUTH_REDIRECT_URI || `${window.location.origin}${ROUTES.authCallback}`;
}

/** Build the full `/oauth2/authorize` URL for a fresh sign-in attempt. */
export function buildAuthorizeUrl(state: string): string {
  const url = new URL(oauthConfig.authorizeUrl);
  url.searchParams.set('client_id', oauthConfig.clientId);
  url.searchParams.set('redirect_uri', getRedirectUri());
  url.searchParams.set('state', state);
  url.searchParams.set('scope', oauthConfig.scope);
  url.searchParams.set('response_type', oauthConfig.responseType);
  return url.toString();
}
